import { Theme } from '@mui/material';

const AppBar = (theme: Theme) => {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderBottomColor: '#000',
          borderBottomStyle: 'solid',
          borderBottomWidth: 2,
          borderTop: 'none',
          borderLeft: 'none',
          borderRight: 'none',
          boxShadow: 'none',
        },
        positionFixed: {
          zIndex: theme.zIndex.drawer + 1,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
        },
      },
    },
  };
};

export default AppBar;
